import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { CommonResponseModel, driverIdReq, LocationDto, PlantIdReq } from "@project-management-system/shared-models";
import { LocationsService } from "./locations.service";
import { LocationsDto } from "./dto/locations-dto";

@Controller('locations')
@ApiTags('/locations')
export class LocationsController {
    constructor(private service: LocationsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/getAllActiveLocations')
    async getAllActiveLocations(): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllActiveLocations();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getAllLocations')
    @ApiBody({ type: driverIdReq })
    async getAllLocations(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllLocations(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/createLocation')
    @ApiBody({ type: LocationsDto })
    async createLocation(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.service.createLocation(req, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }

    }

    @Post('/updateLocation')
    @ApiBody({ type: LocationsDto })
    async updateLocation(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.service.createLocation(req, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }

    }

    @Post('/activateOrDeactivateLocation')
    @ApiBody({ type: LocationDto })
    async activateOrDeactivateLocation(@Body() dto: any, isUpdate: boolean = false): Promise<CommonResponseModel> {
        try {
            return await this.service.activateOrDeactivateLocation(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getActiveAllLocationByPlant')
    @ApiBody({ type: PlantIdReq })
    async getActiveAllLocationByPlant(@Body() dto: any): Promise<CommonResponseModel> {
        try {
            return await this.service.getActiveAllLocationByPlant(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

}